import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import './index.css'
import { Button, Input, Modal, Table, ConfigProvider, notification, Upload, Checkbox } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import ImgCrop from 'antd-img-crop';
import { useNavigate } from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Customer() {
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };

  const initialFields = { 'id': '', 'customerName': '', 'nickName': '', 'phoneNumber': '' };
  const initState = { 'id': '', 'customerName': '', 'nickName': '', 'phoneNumber': '', 'customerName_isVisible': false, 'nickName_isVisible': false, 'phoneNumber_isVisible': false };
  const [state, setState] = useState(initState);
  const [dataSource, setDataSource] = useState([]);
  const [query, setQuery] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  useEffect(() => {
    queryList({});
  }, []); // 空数组确保只在挂载时设置观察者

  let navigate = useNavigate();
  const token = store.getState().uData.token;
  function queryList(data) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/custom/list',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
          setSelectedRowKeys([])
        } else {
          setDataSource({});
          setSelectedRowKeys([])
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const [open, setOpen] = useState(false);

  //查询数据详情
  function modifyShowModal(id) {
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/custom/find',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          setState(response.data.data);
          setModalTitle("编辑客户信息")
          setOpen(true);
        } else {
          openNotificationWithIcon('error', '消息提示', '数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //新增
  const showModal = () => {
    setState(initState);
    setModalTitle("新增客户信息")
    setOpen(true);
  };
  const handleOk = () => {
    handleAddOrModify();
  };
  const handleCancel = () => {
    setOpen(false);
    setFileList([]);
  };

  //删除
  function handleBatchDelete() {
    const checkIds = selectedRowKeys;
    if (checkIds.length === 0) {
      openNotificationWithIcon('warning', '消息提示', '请先选择要删除的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', checkIds.join(","));
    //请求后台接口
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/custom/del',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          const newSelectedRowKeys = [];
          for (let i = 0; i < selectedRowKeys.length; i++) {
            if (!checkIds.includes(selectedRowKeys[i])) {
              newSelectedRowKeys.push(selectedRowKeys[i]);
            }
          }
          setSelectedRowKeys(newSelectedRowKeys);
          queryList(query);
          openNotificationWithIcon('success', '消息提示', '数据删除成功！')
        } else {
          openNotificationWithIcon('error', '消息提示', '数据删除失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  function handleDelete(id) {
    if (id === "") {
      openNotificationWithIcon('warning', '消息提示', '请先选择要删除的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', id);
    //请求后台接口
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/custom/del',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          queryList(query);
          openNotificationWithIcon('success', '消息提示', '数据删除成功！')
        } else {
          openNotificationWithIcon('error', '消息提示', '数据删除失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //添加或者修改
  function handleAddOrModify() {
    let valiad = true;
    //校验
    const { customerName, nickName, phoneNumber, id } = state;
    const items = [
      { name: 'customerName', val: customerName },
      { name: 'nickName', val: nickName },
      { name: 'phoneNumber', val: phoneNumber }
    ];
    let success_msg = "";
    let error_msg = "";
    if (id) {
      success_msg = "数据修改成功！";
      error_msg = "数据修改失败！";
    } else {
      success_msg = "数据新增成功！";
      error_msg = "数据新增失败！";
    }

    items.map(item => {
      if (!item.val) {
        valiad = false;
        return setState(prevState => ({ ...prevState, [item.name + '_isVisible']: true }));
      }
      return null;
    })
    if (valiad) {
      const data = {
        id,
        customerName,
        nickName,
        phoneNumber
      }
      //请求后台接口
      axios.post('/api/custom/addOrModify',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpen(false);
            setFileList([]);
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpen(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    } else {
      setOpen(true);
    }
  }
  //组装Serach组件的查询字段
  const searchFields = [
    {
      fieldName: 'customerName',
      fieldCnName: '客户名称',
      placeholder: '请输入客户名称'
    }, {
      fieldName: 'nickName',
      fieldCnName: '客户昵称',
      placeholder: '请输入客户昵称'
    }, {
      fieldName: 'phoneNumber',
      fieldCnName: '手机号',
      placeholder: '请输入手机号'
    }
  ]


  const handleSearch = (data) => {
    setQuery(data);
    queryList(data);
  };
  const inputChange = (event) => {
    if (!event.target.value) {
      setState({
        ...state,
        [event.target.name]: '',
        [event.target.name + '_isVisible']: true,
      })
    } else {
      setState({
        ...state,
        [event.target.name]: event.target.value,
        [event.target.name + '_isVisible']: false,
      })
    }
  }

  const columns = [
    {
      title: '客户名称',
      // width: 100,
      dataIndex: 'customerName',
      key: 'customerName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '客户昵称',
      // width: 100,
      dataIndex: 'nickName',
      key: 'nickName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '手机号',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      // width: 150,
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.phoneNumber - b.phoneNumber,
      responsive: ['lg'],
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      // width: 100,
      responsive: ['lg'],
      // render: () => <div><a>编辑</a><a>删除</a></div>,
      render: (_, record) => (
        <div>
          <a onClick={() => modifyShowModal(record.id)} style={{ marginRight: '20px' }}>编辑</a>
          <a onClick={() => handleDelete(record.id)}>删除</a>
        </div>
      )
    },
  ];



  const [fileList, setFileList] = useState([]);

  const onChange = ({ fileList: newFileList }) => {
    console.log("info", newFileList)
    setFileList(newFileList);
    if (newFileList.length > 0) {
      if (newFileList[0].status == 'done') {
        if (newFileList[0].response.code === '200') {
          setFileList(newFileList);
        } else {
          openNotificationWithIcon('error', '消息提示', "上传失败,请重试！")
          setFileList([]);
        }
      }
    } else {
      setFileList([]);
    }
  }

  const onPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 客户管理页
      </div>

      <Serach fields={searchFields} initState={initialFields} onSearch={handleSearch} />

      <div className="data-div">
        <div className="bt_group">
          <Button onClick={showModal} className="bt_group_add"><PlusOutlined />新增</Button>
          <Button className="bt_group_batch_close" onClick={handleBatchDelete}><DeleteOutlined />批量删除</Button>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            rowSelection={rowSelection}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: 'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>

      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div>
          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>客户名称:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入商户名称" name='customerName' value={state.customerName} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.customerName_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入商户名称</span></div>
          </div>

          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>客户手机号:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入客户手机号" name='phoneNumber' value={state.phoneNumber} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.phoneNumber_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入客户手机号</span></div>
          </div>

          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>客户昵称:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入客户昵称" name='nickName' value={state.nickName} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>头像上传:</span>
            </div>
            <div style={{ width: '90%' }}>
              <ImgCrop rotationSlider>
                <Upload
                  action="/api/custom/upload"
                  headers={{ token }}
                  listType="picture-card"
                  fileList={fileList}
                  onChange={onChange}
                  onPreview={onPreview}
                  maxCount='1'
                >
                  {fileList.length < 1 && '+ Upload'}
                </Upload>
              </ImgCrop>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>

  )
}
